export const calculateTotalPages = (
  itemCountPerPage: number,
  totalItemCount: number,
): number => {
  if (
    !itemCountPerPage ||
    !totalItemCount ||
    !Number.isFinite(itemCountPerPage) ||
    !Number.isFinite(totalItemCount) ||
    totalItemCount < 1 ||
    itemCountPerPage < 1
  ) {
    return 0;
  }

  return Math.ceil(totalItemCount / itemCountPerPage);
};
